<ngx-smart-modal #wtSubscribeModal disableRefocus identifier="wtSubscribeModal" [customClass]="'wt-subscribe-modal'">
    <div class="wt-subscribe-content">
        <h2 class="wt-modal-title">Enable Website Texting</h2>

        <div class="wt-trial-banner" *ngIf="isTrialing">
            <ng-icon [name]="'heroGift'" [size]="'22px'" [color]="'#F59E0B'"></ng-icon>
            <div class="wt-trial-banner-text">
                <span class="wt-trial-banner-title">Free for the rest of your trial</span>
                <span class="wt-trial-banner-desc">Turn on Website Texting now at no charge. You won't be billed
                    until your trial ends — cancel anytime before then.</span>
            </div>
        </div>

        <div class="wt-pricing-card">
            <div class="wt-pricing-header">
                <span class="wt-pricing-name">Website Texting</span>
                <span class="wt-addon-badge">ADD-ON</span>
            </div>
            <div class="wt-pricing-amount">
                <span class="wt-price">$50</span>
                <span class="wt-interval">per month</span>
            </div>
            <p class="wt-trial-billing" *ngIf="isTrialing">
                Free during your trial — billing starts <strong>{{ trialEndsAt | date:'longDate' }}</strong>
            </p>
            <div class="wt-pricing-divider"></div>
            <div class="wt-pricing-features">
                <div class="wt-feature">
                    <ng-icon [name]="'heroCheckCircle'" [size]="'20px'" [color]="'#822AC6'"></ng-icon>
                    <span>25 conversations included per month</span>
                </div>
                <div class="wt-feature">
                    <ng-icon [name]="'heroCheckCircle'" [size]="'20px'" [color]="'#822AC6'"></ng-icon>
                    <span>$1 per additional conversation</span>
                </div>
            </div>
        </div>
        <div class="wt-promo-applied" *ngIf="isEligibleForWtPromo">
            <ng-icon [name]="'heroTagSolid'" [size]="'13px'" [color]="'#9332E0'"></ng-icon>
            {{ '$50 credit applied' }}
        </div>
        <rosie-button (click)="subscribe()" [inProgress]="isSubscribing" class="d-block wt-subscribe-btn"
            [customClass]="'slim text-sm'" [translationKey]="'Enable Website Texting'">
        </rosie-button>
        <p class="wt-terms-text" *ngIf="isTrialing; else regularTerms">
            No charge today. By enabling Website Texting, you agree to monthly charges and overages when your trial
            ends.
            <a href="https://heyrosie.com/terms" target="_blank" class="wt-terms-link">Terms of Service</a>
        </p>
        <ng-template #regularTerms>
            <p class="wt-terms-text">
                By enabling Website Texting, you agree to monthly charges and overages
                <a href="https://heyrosie.com/terms" target="_blank" class="wt-terms-link">Terms of Service</a>
            </p>
        </ng-template>
    </div>
</ngx-smart-modal>